import {
  ITelemetryPlugin,
  IPlugin,
  IEventProperty,
  IExtendedConfiguration,
  IAppInsightsCore,
  ITelemetryItem,
  BaseTelemetryPlugin,
  IProcessTelemetryContext
} from '@ms/1ds-core-js';
import { addOneDSFields } from './GetOneDSData';
import { DataField } from '@ms/oteljs';

export class PartAPlugin extends BaseTelemetryPlugin implements ITelemetryPlugin {
  public identifier = 'PartAPlugin';
  public priority = 3;
  private _properties: { [name: string]: IEventProperty | string | boolean } = {};

  initialize(_coreConfig: IExtendedConfiguration, _core: IAppInsightsCore, _extensions: IPlugin[]) {
    super.initialize(_coreConfig, _core, _extensions);
  }

  /**
   * Process the event and add part A fields to it.
   * @param {object} event - The event that needs to be stored.
   */
  processTelemetry(event: ITelemetryItem, itemCtx?: IProcessTelemetryContext) {
    event.data = { ...event.data, ...this._properties };

    let itemContext: IProcessTelemetryContext = this._getTelCtx(itemCtx);

    this.processNext(event, itemContext);
  }

  /**
   * Add properties to send on every event
   * @param properties Properties to send on every event
   */
  addDataFields(dataFields: DataField[]) {
    addOneDSFields(this._properties, dataFields, false);
  }
}
